module.exports = __webpack_public_path__ + "img/icon-reorder-drag-and-drop.7f077836.svg";